import appClient from './appClient';

export const getStores = async () => {
    try {
        // Логируем запрос
        console.log('Fetching stores from API...');

        // Выполняем запрос
        const response = await appClient.get(`/store`);

        // Логируем успешный ответ
        console.info('API getStores response:', response.data);

        // Преобразуем данные в строки
        const stores = response.data.map(store =>
            Object.fromEntries(
                Object.entries(store).map(([key, value]) => [key, String(value)])
            )
        );

        return stores;  // Возвращаем преобразованные данные
    } catch (error) {
        // Логируем ошибку
        console.error('Error fetching stores:', error);

        // Выбрасываем ошибку для обработки в вызывающем коде
        throw new Error('Failed to fetch stores');
    }
};
//TODO check if this is correct
export const getStoreById = async (storeId) => {
    try {
        // Логирование входных данных
        console.log('Fetching store by ID:', storeId);

        // Выполняем запрос
        const response = await appClient.get(`/store-by-id?storeId=${storeId}`);

        // Проверка на наличие данных в response
        if (!response.data || !response.data.store) {
            throw new Error(`Store with ID ${storeId} not found`);
        }

        // Преобразование значений объекта в строки
        const store = Object.fromEntries(
            Object.entries(response.data.store).map(([key, value]) => [key, String(value)])
        );

        // Логирование успешного результата
        console.log('Store fetched successfully:', store);

        return store;  // Возвращаем преобразованные данные
    } catch (error) {
        // Логирование ошибок
        console.error(`Error fetching store by ID ${storeId}:`, error);

        // Выбрасываем ошибку для обработки в вызывающем коде
        throw new Error(`Failed to fetch store by ID ${storeId}`);
    }
}